/* eslint-disable react/display-name */
import Controller from './Controller'

export default Controller
